import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import * as React from 'react';
import { createElement } from 'react';
import styled from 'styled-components';
import { spacing8x } from '../../styles/spacing.js';
import { mergeProps } from '../../utils/react.js';
import { useButtonMenuContext } from '../ButtonMenuContainer/ButtonMenuContainer.js';
import { ButtonMenuItem } from '../ButtonMenuItem/ButtonMenuItem.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var Container = styled.ul.withConfig({
  displayName: "ButtonMenuItemGroup__Container",
  componentId: "sc-1rr7nhj-0"
})(["&&{padding-inline-start:0;}"]);
var Header = styled.div.withConfig({
  displayName: "ButtonMenuItemGroup__Header",
  componentId: "sc-1rr7nhj-1"
})(["&&{display:flex;align-items:center;color:", ";font-size:14px;line-height:18px;font-weight:600;height:", ";padding:5px 10px;cursor:default;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.neutralColors.charcoal;
}, spacing8x);
var ButtonMenuItemGroup = function ButtonMenuItemGroup(props) {
  var context = useButtonMenuContext();
  var content;
  if (props.menuItems !== void 0) {
    content = props.menuItems.map(function (item, index) {
      var _props$firstItemIndex;
      var buttonMenuItemProps = item;
      var isLastItem = props.menuItems.length - 1 === index;
      return /*#__PURE__*/createElement(ButtonMenuItem, _objectSpread(_objectSpread({}, buttonMenuItemProps), {}, {
        ariaLabelPrefix: props.label,
        key: index,
        itemIndex: ((_props$firstItemIndex = props.firstItemIndex) !== null && _props$firstItemIndex !== void 0 ? _props$firstItemIndex : 0) + index,
        border: isLastItem,
        ref: isLastItem ? context.lastItemRef : void 0,
        onActivate: function onActivate(e) {
          if (buttonMenuItemProps.onActivate) {
            buttonMenuItemProps.onActivate(e);
          }
          if (props.onActivate) {
            props.onActivate(buttonMenuItemProps);
          }
        }
      }));
    });
  } else {
    content = React.Children.map(props.children, function (child, index) {
      var _props$firstItemIndex2;
      if (! /*#__PURE__*/React.isValidElement(child)) return child;
      var item = child;
      var isLastItem = Array.isArray(props.children) && props.children.length - 1 === index;
      return /*#__PURE__*/React.cloneElement(item, mergeProps(_objectSpread(_objectSpread({}, item.props), {}, {
        ref: item.ref
      }), {
        ariaLabelPrefix: props.label,
        border: isLastItem,
        itemIndex: ((_props$firstItemIndex2 = props.firstItemIndex) !== null && _props$firstItemIndex2 !== void 0 ? _props$firstItemIndex2 : 0) + index,
        ref: isLastItem ? context.lastItemRef : void 0
      }));
    });
  }
  return /*#__PURE__*/jsxs("li", {
    role: "presentation",
    children: [/*#__PURE__*/jsx(Header, {
      role: "presentation",
      "aria-hidden": true,
      children: props.label
    }), /*#__PURE__*/jsx(Container, {
      role: "presentation",
      children: content
    })]
  });
};
ButtonMenuItemGroup.displayName = "ButtonMenuItemGroup";

export { ButtonMenuItemGroup };
